var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as cn from "classnames";
import * as React from "react";
import SearchInput from "../searchInput";
import SearchInputCancelButton from "../searchInputCancelButton";
import * as styles from "./styles.css";
var SearchForm = /** @class */ (function (_super) {
    __extends(SearchForm, _super);
    function SearchForm(props) {
        var _this = _super.call(this, props) || this;
        _this.handleInputChange = function (e) {
            _this.setState({
                input: e.target.value,
            });
        };
        _this.handleClickCloseButton = function () {
            var onSearch = _this.props.onSearch;
            _this.setState({
                input: "",
            }, function () {
                _this.inputComponent.focus();
                onSearch("");
            });
        };
        _this.handleSearch = function (e) {
            e.preventDefault();
            _this.props.onSearch(_this.state.input);
            _this.inputComponent.blur();
        };
        _this.state = {
            input: props.input || "",
        };
        return _this;
    }
    SearchForm.prototype.componentDidMount = function () {
        if (this.inputComponent) {
            this.inputComponent.focus();
        }
    };
    SearchForm.prototype.componentWillReceiveProps = function (nextProps) {
        this.setState({
            input: nextProps.input,
        });
    };
    SearchForm.prototype.render = function () {
        var _this = this;
        var _a = this.props, className = _a.className, placeholder = _a.placeholder;
        var input = this.state.input;
        return (React.createElement("form", { className: cn(styles.searchForm, className), onSubmit: this.handleSearch },
            React.createElement(SearchInput, { value: input, className: styles.searchInput, placeholder: placeholder || "Search", onChange: this.handleInputChange, innerRef: function (node) { return (_this.inputComponent = node); } }),
            input && (React.createElement(SearchInputCancelButton, { className: styles.searchInputCancelButton, onClick: this.handleClickCloseButton }))));
    };
    return SearchForm;
}(React.Component));
export { SearchForm };



//////////////////
// WEBPACK FOOTER
// ./app/modules/search/components/searchForm/index.tsx
// module id = W66V
// module chunks = 2